import React from 'react'
import Header from "../../components/header/Header"
import Footer from "../../components/footer/Footer"
import Testimonial from '../../components/testimonial/Testimonial';
import Services from '../../components/services/Services';
import Posterimage from '../../components/posterimage/Posterimage';
import Videos from '../../components/videos/Videos';
import Formcontainer from '../../components/forms/formcontainer';

export default function Home() {
    return (
        <div>
            <Header />
            <Posterimage />
            <Services />
            <Videos />
            <Formcontainer />
            <Testimonial />
            <Footer />
        </div>
    )
}
